import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=01e4149d&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=01e4149d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e4149d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01e4149d')) {
      api.createRecord('01e4149d', component.options)
    } else {
      api.reload('01e4149d', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=01e4149d&scoped=true&", function () {
      api.rerender('01e4149d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2AVpQUHP1xxA0/JS/comp/CookieBox.vue"
export default component.exports